import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestformHomeComponent } from './requestform-home.component';

const routes: Routes = [
  {
    path: '',
    component: RequestformHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RequestformHomeRoutingModule {}
